import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  transformCalculatedParametersToOptions,
  getCalculatedParameterId,
} from "../../utils/analysisContextUtils";
import { getCalculaterParameter } from "../../../../redux/apiCalls/parametersCall/parameterCalculatedCall";

const CalculatedParameterSelector = ({
  value,
  onChange,
  deviceId,
  branchId,
  userToken,
  dispatch,
}) => {
  const parameters = useSelector(
    (state) => state.parametrosCalculados.currentParametrosCalculados
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userToken || (!deviceId && !branchId)) return;

    const fetchParameters = async () => {
      setLoading(true);
      try {
        await getCalculaterParameter(dispatch, userToken, deviceId);
      } catch (error) {
        console.error("Error fetching calculated parameters:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchParameters();
  }, [userToken, deviceId, branchId, dispatch]);

  const parameterOptions = useMemo(() => {
    if (!Array.isArray(parameters)) return [];
    return transformCalculatedParametersToOptions(parameters).map((option) => ({
      ...option,
      apiId: getCalculatedParameterId(option),
    }));
  }, [parameters]);

  const handleChange = (e) => {
    const selectedId = e.target.value;
    if (!selectedId) {
      onChange(null);
      return;
    }

    const selected = parameterOptions.find(
      (p) => String(p.apiId) === selectedId
    );
    if (selected) {
      onChange({
        id: selected.apiId,
        name: selected.label,
        unit: selected.unit,
        scope: selected.scope,
      });
    }
  };

  if (!branchId && !deviceId) {
    return (
      <div className="selector-wrapper">
        <select className="field-select" disabled>
          <option>Seleccioná una sucursal primero</option>
        </select>
        <div className="field-hint">
          Debes seleccionar una sucursal para ver los parámetros calculados disponibles
        </div>
      </div>
    );
  }

  return (
    <div className="selector-wrapper">
      <select
        className="field-select"
        value={value?.id || ""}
        onChange={handleChange}
        disabled={loading || parameterOptions.length === 0}
      >
        <option value="">
          {loading
            ? "Cargando parámetros..."
            : parameterOptions.length === 0
            ? "No hay parámetros calculados disponibles"
            : "Seleccionar parámetro..."}
        </option>
        {parameterOptions.map((param) => (
          <option key={param.apiId} value={param.apiId}>
            {param.label}
          </option>
        ))}
      </select>
      {value && <div className="selected-value">{value.name}</div>}
    </div>
  );
};

export default CalculatedParameterSelector;
